import { render, staticRenderFns } from "./manager_dashboard.vue?vue&type=template&id=723b3c19&"
import script from "./manager_dashboard.vue?vue&type=script&lang=js&"
export * from "./manager_dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports